var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSend({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 22,
    viewBox: "0 0 23 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.312254 2.25247C0.0109901 1.41703 0.867027 0.632705 1.67298 1.00573L20.4393 9.6914C20.9256 9.91647 20.7651 10.6452 20.2293 10.6452H4.04113C3.61965 10.6452 3.24341 10.3809 3.10043 9.98439L0.312254 2.25247Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0.312254 19.7475C0.0109901 20.583 0.867027 21.3673 1.67298 20.9943L20.4393 12.3086C20.9256 12.0835 20.7651 11.3548 20.2293 11.3548H4.04113C3.61965 11.3548 3.24341 11.6191 3.10043 12.0156L0.312254 19.7475Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSend);
export default __webpack_public_path__ + "static/media/send.23107b6b30e84feac127d8ddeef4f079.svg";
export { ForwardRef as ReactComponent };